import { fetchLogIn, getMissingRequiredInfo } from 'containers/Login/loginSlice'
import { useHistory } from 'react-router-dom'
import Loading from 'components/Loading'
import React, { useEffect } from 'react'
import { useReduxDispatch } from 'store'

const Finish: React.FC = () => {
  const dispatch = useReduxDispatch()
  const { replace } = useHistory()
  useEffect(() => {
    const query = new URLSearchParams(window.location.search)
    const magic_token = query.get('magic_token')
    if (magic_token) {
      dispatch(fetchLogIn({ magic_token })).then(res => {
        replace(getMissingRequiredInfo(res.payload) ? '/registration' : '/login')
      })
    } else {
      replace('/login')
    }
  }, [dispatch, replace])

  return (
    <Loading />
  )
}

export default Finish